import React, { Fragment, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Tooltip } from 'react-tooltip';

import MemoryformLifeform from "./MemoryformLifeform";
import translate from "../services/translate";

const MemoryformForm = ({ lengthErr, prompt, onChange, onSubmit, data }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ mode: 'onChange', reValidateMode: 'onChange'})

  //const watchedText = watch(["maintext", ...fields]);
  const watchedText = watch();

  useEffect(() => {
    onChange(watchedText, errors);
  }, [watchedText, onChange, errors]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Tooltip
        id="memformtippy"
        style={{ backgroundColor: "rgb(0, 0, 0)", color: "white", padding: "1rem", borderRadius: "20px"}}
      />
      <div className="memoryformIntro">
      <p>You created {data.createdCount} lifeforms, you killed {data.killedCount}, and you otherwise interacted with lifeforms {data.distributions} times</p>
      {data.carePatterns.length > 0 ? (
        <p>Your care patterns were: 
          {data.carePatterns.map((i) => {
            if (i !== "Creator" && i !== "Killer") {
              return (
                <Fragment key={i}>
                <a key={i.id} className="carePat" data-tooltip-id="memformtippy" data-tooltip-content={translate(`patterns.${[i]}`)}>
                  {`${i}${data.carePatterns[data.carePatterns.length-1] === i ? "" : ", "}`}
                </a>
                </Fragment>
              )
            } else { return null }
          })
        }</p>
      ) : null}
      <p>All of the questions here are optional</p>

      {/* errors will return when field validation fails  */}
      {errors.maintext && <p><span className="error">Sorry, only ascii characters allowed</span></p>}
      {lengthErr && <p><span className="error">Currently your responses are too long and will be cut off on the final image. I advise making them shorter</span></p>}

      {data.memoryformlifeforms.map((i) => {
        return <MemoryformLifeform
          key={i.id}
          id={i.lifeform.tokenId}
          register={register}
          errors={errors}
          mem={i} />
      })}

      <p className="prompt promptTop">{prompt}</p>
      <p className="prompt"><input className="text" {...register("maintext", { pattern: /^[\x00-\x7F]*$/ })} /></p>

      <p><input type="checkbox" value="" {...register("approve")}/>{translate('Memoryform.approved')}</p>

      <div className="button-parent"><input type="submit" value="Generate metadata"/></div>
      </div>
    </form>
  )
}

export default MemoryformForm;